<!--Renders the structure of the whole website with the consistent navbar, content,
    and footer.
-->

<template>
  <div>
    <home-app-bar />
    <home-view />
    <home-footer />
  </div>
</template>

<script>
export default {
  name: "HomeLayout",

  components: {
    HomeAppBar: () => import("@/components/nav/AppBar"),
    HomeFooter: () => import("@/layouts/home/Footer"),
    HomeView: () => import("@/layouts/home/View"),
  },
};
</script>